import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import { ArrowBack as BackIcon } from "@mui/icons-material";

const AdminConsoleHeader = ({
  isRailCollapsed,
  homePath,
  onNavigate,
}) => {
  if (isRailCollapsed) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Tooltip title="Back to app" placement="right" arrow>
          <Button
            component={RouterLink}
            to={homePath}
            onClick={onNavigate}
            aria-label="Back to app"
            sx={{ minWidth: 0, px: 1, color: "text.secondary" }}
          >
            <BackIcon fontSize="small" />
          </Button>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          color: "warning.main",
          fontWeight: 700,
          letterSpacing: "0.1em",
        }}
      >
        ADMIN CONSOLE
      </Typography>
      <Button
        component={RouterLink}
        to={homePath}
        onClick={onNavigate}
        startIcon={<BackIcon />}
        size="small"
        sx={{ mt: 0.5, px: 0.5, color: "text.secondary" }}
      >
        Back to app
      </Button>
    </Box>
  );
};

export default AdminConsoleHeader;
